import { handleActions } from 'redux-actions';

export const QRCODE_ATTEMPT_ACTION = 'QRCODE/ATTEMPT/SET';

export const reducer = handleActions(
  {
    [QRCODE_ATTEMPT_ACTION]: (_, action) => action.payload,
  },
  { dataUrl: '', originUrl: '' },
);

export default reducer;
